import Navbar from "../components/Navbar/Navbar";
import ProfileForm from "../components/profile-forms/ProfileForm";

const ProfileFormPage = () => {
    return ( 
        <>
        <Navbar/>
        <ProfileForm/>
        </>
     );
}
 
export default ProfileFormPage;